<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span slot="button" v-if="permissionChecker('Role.Create')">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
    >
      <template slot="selfactions" slot-scope="rowKey">
        <span>
            <a href="javascript:;" @click="handleEdit(2,rowKey.data)">详情</a>
             <a-divider type="vertical"/>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('Role.Edit')">编辑</a>
          <a-divider type="vertical"/>
          <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="rowKey.data.isStatic || !permissionChecker('Role.Delete')" >删除</a>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-role-add
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="addVisible = false"
        :params="params"
      ></hp-manager-page-role-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageRoleAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {

    hpManagerPageRoleAdd
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "角色"
        },
        {
              type: "input",
          key: "displayName",
          name: "显示名称"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: "10%",
          scopedSlots: { customRender: "action" }
        },
        {
          title: "角色",
          width: "15%",
          dataIndex: "name",
          sorter: true,
        },
         {
          title: "显示名称",
          width: "15%",
          dataIndex: "displayName",
          sorter: true,
        },
        {
          title: " 角色描述",
          width: 150,
          dataIndex: "description",
          width: "15%",
          sorter: true
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          width: "15%",
          customRender: (text, row, index) => {
            return (row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss"));
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", displayName: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      title:""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
        handleSubmit(p) {
      this.pagination.current=0;  
      this.filterdata.name = p.values.name;
      this.filterdata.displayName = p.values.displayName;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      this.isStatic = false;
      if (type == 1) {
        this.title = "编辑角色";
        this.isStatic = record.isStatic;
      } else if (type == 2) {
        this.title = "角色详情";
        this.isabl = true;
      } else {
        this.title = "新增角色";
      }
      this.params = Object.assign({ isShow: this.isabl, isStatic:this.isStatic}, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelRole({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {this.pagination.current=0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetRoleList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Admins/Role/List.vue